module.exports = __webpack_public_path__ + "src/assets/audio/beeBuzz3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/beeBuzz3.mp3
// module id = ./src/assets/audio/beeBuzz3.mp3
// module chunks = 0